import { render, staticRenderFns } from "./favorites.vue?vue&type=template&id=6a9e0995"
import script from "./favorites.vue?vue&type=script&lang=js"
export * from "./favorites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports